import ENDPOINTS from '../../../const/endpoints';
export const changePaymentDueDateGetCacheKey = ({ accountId, accountIdType }) => [
    `Get-${ENDPOINTS.changePaymentDueDate}`,
    { accountId, accountIdType }
];
